import React from 'react';

function Footer() {
    return <div className="text-right"></div>;
}

export default Footer;
